import { useQuery } from "@tanstack/react-query";
import { oldBaseApi } from "@/entities/api";
import { ExecutionDataResponse } from "../types/execution-data";

interface UseExecutionDataParams {
  itemNoVersionId: string;
  pageNumber?: number;
  pageSize?: number;
  searchValue?: string;
  statuses?: string[];
  actDateStart?: string;
  actDateEnd?: string;
}

export const useExecutionData = ({
  itemNoVersionId,
  pageNumber = 0,
  pageSize = 1000,
  searchValue = "",
  statuses = ["SIGNED"],
  actDateStart = "2024-05-01",
  actDateEnd = new Date().toISOString().split("T")[0],
}: UseExecutionDataParams) => {
  return useQuery<ExecutionDataResponse>({
    queryKey: [
      "executionData",
      itemNoVersionId,
      pageNumber,
      pageSize,
      searchValue,
      statuses,
      actDateStart,
      actDateEnd,
    ],
    queryFn: async () => {
      const response = await oldBaseApi.post<ExecutionDataResponse>(
        `/api/work_three/by-ozhr-item-id/${itemNoVersionId}/acts`,
        {
          pageNumber,
          pageSize,
          searchValue,
          statuses,
          actDateStart,
          actDateEnd,
        },
      );
      return response.data;
    },
    enabled: !!itemNoVersionId,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
  });
};

